        <template>
    <div>
    <div v-if="!cookiesObject.token">
    <p class="goldenP goldLogin"> {{ $t('LanguageEn.loginGuest') }} <button type="button" class="loginButton btn btn-primary" data-toggle="modal" data-target="#exampleModal">{{ $t('LanguageEn.loginButton') }}</button> </p> 
<div class="modal fade " id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered ">
    <div class="modal-content ">
      <div class="modal-body" style="margin-bottom: -25px;"> 
        <img src="@/assets/soccer-cover.jpg" style="width: 498px; height: 100%; margin-top: -16px; margin-left: -15.6px;">
      </div>
      <div class="modal-footer ">
        <VuePhoneNumberInput v-model="number" @update="onUpdate" maxlength="13" style="" class="col" :default-country-code="cookiesObject.countryCode"/> 
        <button type="button" class="loginButton btn btn-primary col-2 " style="margin-top: 3.1px; margin-right: auto; font-size: 12px;"  data-dismiss="modal" v-on:click="numberCookie(), regSign()">{{ $t('LanguageEn.txtNext') }}</button>
      </div>
    </div>
  </div>
</div>
<!-- <div class="modal fade " id="exampleModal1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered ">
    <div class="modal-content ">
      <div class="modal-body" style="margin-bottom: -25px;"> 
        <img src="@/assets/soccer-cover.jpg" style="width: 498px; height: 100%; margin-top: -16px; margin-left: -16px;">
      </div>
      <div class="modal-footer">
        <input type="phone" class="form-control col" id="exampleFormControlInput1" placeholder="Received Code" v-model="OTP" style="margin-left: 10px;">
        <button type="button" class="loginButton btn btn-primary col-2" style="margin-top: 3.1px; font-size: 12px;" data-toggle="modal" data-target="#exampleModal1" v-on:click="verify(), reLoad(), tokenToCookie()">{{ $t('LanguageEn.txtSubmit') }}</button>
      </div>
    </div>
  </div>
</div> -->

    </div>
    <div v-else>
    <p class="goldenP goldLogin" style="font-weight: 600;">{{cookiesObject.number}} <b-btn v-on:click="logout()" class="bg-transparent" style="color: white; border: none; margin-top: -25px; float: right;"><img style="width: 35px; margin-top: 13px;" src="@/assets/logout_button.png"></b-btn></p>        
    </div>
    <b-modal ref="otp-modal" centered style="" hide-footer hide-header title="" >
        <div class="modal-body" style=""> 
        <img src="@/assets/soccer-cover.jpg" style="width: 498px; height: 100%; margin-top: -32px; margin-left: -32px;">
      </div>
        <b-row>
        <b-col cols="9">
        <input type="phone" class="form-control" maxlength="5"  id="exampleFormControlInput1" placeholder="Received Code" v-model="OTP" style="margin-left: 10px;">
        </b-col>
        <b-col>
        <button type="button" class="loginButton btn btn-primary" style="margin-top: 3.1px; font-size: 12px;" data-toggle="modal" data-target="#exampleModal1" v-on:click="verify()">{{ $t('LanguageEn.txtSubmit') }}</button>
        </b-col>
        </b-row>
    </b-modal>
     <b-modal ref="regText-modal" centered style="" hide-footer hide-header title="" >
       <div>
        <img src="@/assets/soccer-cover.jpg" style="width: 467px;">
        </div>
        <p v-if="introText.code == 200" style="margin-top: 10px;">{{introText.page.text}}</p>
        <b-row>
        <b-col>
            <button type="submit" class="btn mbtn btn-default btn-block"  style="z-index: 0; background: none; color: #ff324d;" @click="$refs['regText-modal'].hide()">Cancel</button>
        </b-col>
        <b-col>
            <button type="submit" class="btn btn-default btn-block" style="z-index: 0; background: none; color: #228c39;" @click="$refs['regText-modal'].hide(), $refs['otp-modal'].show()">{{ $t('LanguageEn.txtConfirm') }}</button>
        </b-col>
        </b-row>
    </b-modal>
    <b-modal ref="error-modal" size="sm" hide-footer hide-header>
        <p style="text-align: center;">{{errorText}}</p>
        <b-row>
        <b-col style="text-align: left;">
        </b-col>
        <b-col style="text-align: right;">
            <b-button  type="submit" class="" @click="$refs['error-modal'].hide()" variant="outline-success">CLOSE</b-button>
        </b-col>
        </b-row>
    </b-modal>
    </div>
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input';
import {mapGetters} from 'vuex';

export default {
  name: 'LoginP',
   data(){
      return{
          OTP: '',
          number: '',
          portalLenght: '',
          regOrNot: '',
          token: '',
          clientToken: 'Web_'+ Date.now() + '_' + this.number,
          username: '',
          cookiesObject: '',
          UserName: '',
          results: {},
          introText: '',
          errorText: '',
      }
  },
  async beforeMount(){
    var res = await fetch(this.httpReq + '/general/appData');
    var data = await res.json();
    var portalLenght = data.portals.length;
    this.portalLenght = portalLenght;

    var cookiesObject = document.cookie.split(';').map(cookie => cookie.split('=')).reduce((accumulator, [key, value]) => ({...accumulator, [key.trim()]: decodeURIComponent(value)}),{});
    this.cookiesObject = cookiesObject;

    var resp = await fetch(this.httpReq + '/general/page?languageId='+ this.cookiesObject.langId +'&link=registration_intro&portalId=' + this.cookiesObject.portalId);
    var dataa = await resp.json();
    this.introText = dataa; 

  },

  methods:{
    // opMod(){
    //   this.$("#exampleModal1").modal({show: true});
    // },

    logout(){
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "lang = en; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
         location.assign("/");
    },
    numberCookie(){
       document.cookie = 'number =' + this.number + ';expires = Thu, 01 Jan 2040 00:00:00 GMT;';
    },
    async regSign(){
    var res = await fetch(this.httpReq + '/user/status?msisdn=' + this.results.formattedNumber.slice(1));
    var data = await res.json();
    var regOrNot = data.code; 

    this.regOrNot = regOrNot;

    // if (regOrNot == 404) {
    //   this.$refs['otp-modal'].show()
    // }

    if (regOrNot == 200) {
    var res1 = await fetch(this.httpReq + '/user/login/otp?msisdn=' + this.results.formattedNumber.slice(1) , { method: 'post'});
    await res1.json();

    this.$refs['otp-modal'].show()

    } else if (regOrNot == 404) {

      if (data.portals.length == 0) {
        this.errorText = 'Number is not allowed for service'
        this.$refs['error-modal'].show();
      } else {

      var res2 = await fetch(this.httpReq + '/user/register/otp?msisdn=' + this.results.formattedNumber.slice(1) + '&portalId=' + data.portals[0].id , { method: 'post'});
      var dataresp = await res2.json();

      if (this.cookiesObject.regText == 1) {
      this.$refs['regText-modal'].show()
        } else {
      this.$refs['otp-modal'].show()
        }     

      if (dataresp.code == 200) {
        // ok cool  
    }
    else if (dataresp.code == 405) {
        this.errorText = 'Already registered';
        this.$refs['error-modal'].show();
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
    } else if(dataresp.code == 404){
        this.errorText = 'Portal not found';
        this.$refs['error-modal'].show();
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
         location.assign("/");
    }
    else if(dataresp.code == 500){
        this.errorText = 'Server Side error';
        this.$refs['error-modal'].show();
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
         location.assign("/");
    } else if(dataresp.code == 818){
        this.errorText = 'Subscription system error';
        this.$refs['error-modal'].show();
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
         location.assign("/");
    } else {
        this.errorText = 'Server error';
        this.$refs['error-modal'].show();
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
         location.assign("/");
    }
    } 
    }
    this.regOrNot = regOrNot;
    
    },
    async verify(){

    if (this.regOrNot == 404) {

    var res3 = await fetch(this.httpReq + '/user/register/verify?clientToken='+ this.clientToken +'&msisdn='+ this.results.formattedNumber.slice(1) +'&otp=' + this.OTP , {method: 'post'});
    var data3 = await res3.json();
    var token = data3.token;
    this.token = token;

    if (data3.code == 406) {
        this.errorText = 'You entered Wtong OTP';
        this.$refs['error-modal'].show();
    }else if(data3.code == 500){
         this.errorText = 'Server error, try logging later';
        this.$refs['error-modal'].show();
    } else if (data3.code == 200){

   document.cookie = 'token =' + this.token + ';expires = Thu, 01 Jan 2040 00:00:00 GMT;';

    var res13 = await fetch(this.httpReq + '/general/appData?token=' + this.token);
    var data13 =  await res13.json();
    document.cookie = 'portalId =' + data13.portal.id + ';expires = Thu, 01 Jan 2040 00:00:00 GMT;';
    document.cookie = 'countryCode =' + data13.portal.countryCode;

    this.reLoad();
    }
    else {
        this.errorText = 'Server error, try logging later';
        this.$refs['error-modal'].show();
      document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
       location.assign("/");
    }
    } else if (this.regOrNot == 200){
    var res = await fetch(this.httpReq + '/user/login/verify?clientToken='+ this.clientToken +'&msisdn='+ this.results.formattedNumber.slice(1) +'&otp=' + this.OTP , {method: 'post'});
    var data = await res.json();
    var token1 = data.token;
    this.token = token1;

    if (data.code == 406) {
         this.errorText = 'You entered Wrong OTP';
        this.$refs['error-modal'].show();
    }else if(data.code == 500){
          this.errorText = 'Server error, Try logging later';
        this.$refs['error-modal'].show();
    }
    
    else if(data.code == 200){

   document.cookie = 'token =' + this.token + ';expires = Thu, 01 Jan 2040 00:00:00 GMT;';
    
    var res12 = await fetch(this.httpReq + '/general/appData?token=' + this.token);
    var data12 =  await res12.json();
    document.cookie = 'portalId =' + data12.portal.id + ';expires = Thu, 01 Jan 2040 00:00:00 GMT;';
    document.cookie = 'countryCode =' + data12.portal.countryCode;
    this.reLoad();
    }
    }
    else {
        this.errorText = 'Server error, try logging later';
        this.$refs['error-modal'].show();
      document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
       location.assign("/");
    }

    },
     reLoad(){
      setTimeout(function some() {
               location.assign("/");
      }, 100);
      
    },   
         onUpdate (payload) {
        this.results = payload
      },
    
  },
  components: {
   VuePhoneNumberInput,
  },
  computed:{
    ...mapGetters(['favsTe', 'favs', 'favsT','httpReq']),
    resultsTable () {
        return Object.keys(this.results)
      },
  },
}
</script>

<style scoped>
.goldenP{
    background-image: linear-gradient(to right, #dacb68 , #9b7b23);
    border-radius: 5px;
    height: 45px;
    color: #212529;
    text-align: center;
    font-weight: bold;   
    margin-bottom: 10px; 
    padding-top: 5%;
    font-size: 14px;
    letter-spacing: 1px;
}
    .goldLogin{
    height: 64px;
    justify-content: center;
    padding-top: 10%;
    font-weight: 400;
}

.loginButton{
    background-image: linear-gradient(#39b44a , #1b5f20);
    border: none;
    margin-right: 10px;
    color: white;
    float: right;
    border-radius: 5px;
    height: 37px;
    margin-top: -6px;
}

.blackBG{
    background: #212529;
}


</style>
